/* eslint-disable eslint-comments/disable-enable-pair -- facebook pixel code  */
/* eslint-disable prefer-destructuring -- facebook pixel code */
/* eslint-disable prefer-rest-params -- facebook pixel code  */
/* eslint-disable functional/functional-parameters -- facebook pixel code  */
/* eslint-disable prefer-spread -- facebook pixel code  */
/* eslint-disable no-underscore-dangle -- facebook pixel code  */
/* eslint-disable func-names -- facebook pixel code  */
/* eslint-disable @typescript-eslint/no-unused-expressions -- facebook pixel code  */
/* eslint-disable no-multi-assign -- facebook pixel code  */
import { ApolloClient } from '@apollo/client';
import { ClientEvents, ClientTrackableEvents } from 'common/events/ClientEvents';
import { cleanFbData } from 'common/events/FacebookDataCleaner';
import { SharedEvents } from 'common/events/SharedEvents';
import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
import LinkedInTag from 'react-linkedin-insight';
import { SingularConfig, singularSdk } from 'singular-sdk';
import {
  FacebookTrackEventDocument,
  FacebookTrackEventMutation,
  FacebookTrackEventMutationVariables,
} from 'src/gqlReactTypings.generated.d';
import { isProdEnvironment } from 'src/shared/utils/EnvironmentUtilities';
import { ITracker, UserInfo } from 'src/tracking/types';
import { gtagSetUserData, trackAdwordsEvent } from 'src/vendor/adwords';
import { v4 as uuid } from 'uuid';
import { GoogleTagManagerEventNames, ITagManagerInfo, sendInfoToGoogleTagManager } from '../googleTagManagerUtils';

// Local type definition for purchase item data (not exported from ClientEvents)
type PurchaseItemData = {
  foodItemId: number;
  shefId: string;
  quantity: number;
};

const REACT_APP_SINGULAR_API_KEY = process.env.REACT_APP_SINGULAR_API_KEY;
const REACT_APP_SINGULAR_SECRET_KEY = process.env.REACT_APP_SINGULAR_SECRET_KEY;
const REACT_APP_SINGULAR_PRODUCT_ID = process.env.REACT_APP_SINGULAR_PRODUCT_ID;

const FACEBOOK_PIXEL_ID = '350875572167561';
const StandardFBEventNames = [
  'AddPaymentInfo',
  'AddToCart',
  'AddToWishlist',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'InitiateCheckout',
  'Lead',
  'PageView',
  'Purchase',
  'Schedule',
  'Search',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
  'ViewContent',
];

export class WebAdTracker<T> implements ITracker {
  userInfo?: UserInfo;

  fbclid?: string;

  hasReceivedFirstPageViewEvent = false;

  hasInitializedSingularSdk = false;

  debug = !isProdEnvironment();

  private adTrackingDisabled = false;

  public constructor(public readonly browserTrackerId: string, private readonly apolloClient: ApolloClient<T>) {}

  public setAdTrackingDisabled(disabled: boolean) {
    this.adTrackingDisabled = disabled;
  }

  private getAdTrackerInitializations(): [string, () => void][] {
    return [
      [
        'facebook',
        () => {
          const urlParams = new URLSearchParams(window.location.search);
          let fbcValue = urlParams.get('fbclid');
          if (fbcValue) {
            // If already formatted, use it directly; otherwise, format it.
            fbcValue = fbcValue.startsWith('fb.1.') ? fbcValue : `fb.1.${Math.floor(Date.now() / 1000)}.${fbcValue}`;
          }
          document.cookie = `_fbc=${fbcValue}; path=/;`;
          // New Facebook Pixel Code per Facebook's recommendations: https://developers.facebook.com/docs/meta-pixel/get-started
          (function (f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Element) {
            if (f.fbq) return;
            n = f.fbq = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e) as HTMLScriptElement;
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            // Use non-null assertion to let TS know parentNode exists.
            s.parentNode!.insertBefore(t, s);
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          window.fbq('init', FACEBOOK_PIXEL_ID);
          window.fbq('track', 'PageView');
        },
      ],
      [
        'linkedin',
        () => {
          LinkedInTag.init('3657748', 'px');
        },
      ],
      [
        'singular',
        () => {
          if (!REACT_APP_SINGULAR_API_KEY || !REACT_APP_SINGULAR_SECRET_KEY || !REACT_APP_SINGULAR_PRODUCT_ID) {
            throw new Error('Missing env variables for initializing Singular SDK');
          }

          const config = new SingularConfig(
            REACT_APP_SINGULAR_API_KEY,
            REACT_APP_SINGULAR_SECRET_KEY,
            REACT_APP_SINGULAR_PRODUCT_ID
          ).withInitFinishedCallback(() => {
            this.hasInitializedSingularSdk = true;
          });

          singularSdk.init(config);
        },
      ],
    ];
  }

  private static initGoogleTagManager() {
    const f = document.getElementsByTagName('script')[0];
    function insertScript(path: string) {
      const j = document.createElement('script');
      j.async = true;
      j.src = `https://www.googletagmanager.com${path}`;
      f.parentNode!.insertBefore(j, f);
    }
    // Note: gtag/js is already loaded by ReactGA.initialize() — only load GTM here
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    insertScript('/gtm.js?id=GTM-M9KCS3R');
  }

  public init() {
    const debug = !isProdEnvironment();

    const initializations: [string, () => void][] = [
      [
        'google analytics',
        () => {
          ReactGA.initialize('G-WCZT3E1FD5', { gaOptions: { debug_mode: debug }, gtagOptions: { debug_mode: debug } });
        },
      ],
      ...(this.adTrackingDisabled ? [] : this.getAdTrackerInitializations()),
    ];

    initializations.forEach(([name, init]) => {
      try {
        init();
      } catch (error: unknown) {
        console.error(`Tracker initialization failed ${name}`, error);
      }
    });
  }

  /**
   * Enables ad tracking after CCPA consent is given. Initializes all ad trackers
   * (Facebook, LinkedIn, Singular, GTM, Google Ads) that were skipped during init().
   * Safe to call after init() — each tracker guards against double-initialization.
   */
  public enableAdTracking(): boolean {
    if (!this.adTrackingDisabled) return true;
    let succeeded = true;

    // Initialize ad-specific trackers that were skipped during init()
    // Flag stays true until init succeeds — prevents forwarding events to uninitialized SDKs
    this.getAdTrackerInitializations().forEach(([name, init]) => {
      try {
        init();
      } catch (error: unknown) {
        console.error(`Late tracker initialization failed ${name}`, error);
        succeeded = false;
      }
    });

    // Configure Google Ads (gtag is already loaded by GA)
    try {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      (window as any).gtag?.('config', 'AW-650536379', { allow_enhanced_conversions: true });
    } catch (error: unknown) {
      console.error('Late Google Ads initialization failed', error);
      succeeded = false;
    }

    // Load GTM scripts that were blocked in index.html
    try {
      WebAdTracker.initGoogleTagManager();
    } catch (error: unknown) {
      console.error('Late GTM initialization failed', error);
      succeeded = false;
    }

    // Only flip the flag after initialization — prevents forwarding events to uninitialized SDKs on failure
    if (succeeded) {
      this.adTrackingDisabled = false;
    }

    // If user was already identified, re-identify for ad trackers
    if (succeeded && this.userInfo) {
      this.identify(this.userInfo);
    }

    return succeeded;
  }

  public hasBeenIdentified(): boolean {
    return !!this.userInfo;
  }

  public updateIdentity<I extends keyof UserInfo>(updates: Pick<UserInfo, I>): void {
    if (!this.userInfo) {
      console.error(`updateIdentity called without userinfo initialized`);
      return;
    }

    this.userInfo = {
      ...this.userInfo,
      ...updates,
    };
  }

  public identify(userInfo: UserInfo) {
    this.userInfo = userInfo;

    const matching: {
      external_id: string;
      em: string;
      fn?: string;
      ln?: string;
      zp?: string;
    } = {
      external_id: userInfo.id,
      em: userInfo.email,
    };

    if (userInfo.firstName) {
      matching.fn = userInfo.firstName;
    }
    if (userInfo.lastName) {
      matching.ln = userInfo.lastName;
    }

    if (userInfo.lastSearchedZipCode) {
      matching.zp = userInfo.lastSearchedZipCode;
    }

    if (!this.adTrackingDisabled) {
      window.fbq?.('init', FACEBOOK_PIXEL_ID, matching);

      singularSdk.login(userInfo.id);
      gtagSetUserData(userInfo);
    }
  }

  /**
   * Validates if the _fbc cookie has a valid format.
   * Valid format: fb.{subdomain_index}.{creation_time}.{fbclid}
   * Example: fb.1.1234567890123.AbCdEfGhIjKlMnOpQrStUvWxYz
   * Only send fbc if it contains an actual fbclid from Meta paid traffic
   */
  private isValidFbc(fbc: string | undefined): boolean {
    if (!fbc) return false;
    // Check if fbc follows the expected format: starts with "fb." and has at least 4 parts
    const parts = fbc.split('.');
    return parts.length >= 4 && parts[0] === 'fb' && !!parts[3] && parts[3].length > 0;
  }

  private adwordsTrack(...args: Parameters<typeof trackAdwordsEvent>) {
    if (this.adTrackingDisabled) return;
    trackAdwordsEvent(...args);
  }

  private linkedInTrack(...args: Parameters<typeof LinkedInTag.track>) {
    if (this.adTrackingDisabled) return;
    LinkedInTag.track(...args);
  }

  private singularEvent(...args: Parameters<typeof singularSdk.event>) {
    if (this.adTrackingDisabled) return;
    singularSdk.event(...args);
  }

  private singularRevenue(...args: Parameters<typeof singularSdk.revenue>) {
    if (this.adTrackingDisabled) return;
    singularSdk.revenue(...args);
  }

  private singularPageVisit() {
    if (this.adTrackingDisabled) return;
    singularSdk.pageVisit();
  }

  private gtmTrack(...args: Parameters<typeof sendInfoToGoogleTagManager>) {
    if (this.adTrackingDisabled) return;
    sendInfoToGoogleTagManager(...args);
  }

  private fbTrack(eventName: string, data?: Record<string, any>) {
    if (this.adTrackingDisabled) return;
    const fbcRaw = Cookies.get('_fbc');
    const fbp = Cookies.get('_fbp');
    // Only send fbc if it's valid - prevents "empty fbc parameter" warnings
    const fbc = this.isValidFbc(fbcRaw) ? fbcRaw : undefined;
    const eventID: string = data?.eId ?? uuid();
    const cleanData = cleanFbData(data);
    const dataStringify = JSON.stringify(cleanData);

    // https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking
    if (StandardFBEventNames.includes(eventName)) {
      window.fbq?.('track', eventName, cleanData, { eventID });
    } else {
      window.fbq?.('trackCustom', eventName, cleanData, { eventID });
    }
    if (this.debug) {
      console.info('[facebook-pixel]', ...[eventName, cleanData, { eventID }]);
    }

    this.apolloClient
      .mutate<FacebookTrackEventMutation, FacebookTrackEventMutationVariables>({
        mutation: FacebookTrackEventDocument,
        variables: {
          eventName,
          event: {
            eid: eventID,
            fbc,
            fbp,
            data: dataStringify,
          },
        },
      })
      .catch((e) => console.error(e));
  }

  public track<K extends keyof ClientTrackableEvents>(event: K, eventData: ClientTrackableEvents[K]): void {
    // This runs third-party tracker code that we have no control over. It must be wrapped in try/catch,
    // otherwise bugs in other people's code can break our site!
    try {
      const data = {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ...(eventData as any),
        zipCode: this.userInfo?.lastSearchedZipCode,
        btId: this.browserTrackerId,
        userId: this.userInfo?.id,
        // userEmail removed from event parameters - it's sent as UserData in server-side API, not as event parameter
        pagePath: window.location.pathname,
        pageQueryArgs: window.location.search,
        eId: uuid(),
      };

      const googleTagManagerArgs: ITagManagerInfo = {
        userId: data.userId,
        userEmail: this.userInfo?.email,
        userLoggedIn: !!data.userId,
        pagePath: window.location.pathname,
        pageQueryArgs: window.location.search,
      };

      switch (event) {
        case ClientEvents.PURCHASE: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const purchaseData = data as ClientTrackableEvents[ClientEvents.PURCHASE];

          const subtotalInMajorUnits = purchaseData.subtotal / 100.0;
          // TODO: need to make sure that we don't need to make any changes to google tag manager for reporting group order id for transactionId & googleTagManagerArgs.orderId
          const transactionId = String(purchaseData.groupOrderId);

          googleTagManagerArgs.event = GoogleTagManagerEventNames.PURCHASE_CONVERSION;
          googleTagManagerArgs.conversionSubtotal = subtotalInMajorUnits;
          googleTagManagerArgs.orderId = `${purchaseData.groupOrderId}`;
          // For ad-affiliate networks they can only use one purhcase event, need to add
          // newUserPurchase field to differentiate for GTM
          googleTagManagerArgs.newUserPurchase = purchaseData.orderNumber === 1 ? 1 : 0;

          this.gtmTrack(googleTagManagerArgs);

          // Marketplace Meta event — sent under custom name `MarketplacePurchase` (not standard `Purchase`)
          // so Meta optimization stays WSS-only. Internal `ClientEvents.PURCHASE` is unchanged.
          this.fbTrack('MarketplacePurchase', {
            value: subtotalInMajorUnits,
            currency: 'USD',
            content_ids: purchaseData.items.map((item) => String(item.foodItemId)),
            content_type: 'product',
            contents: purchaseData.items.map((item) => ({
              id: String(item.foodItemId),
              quantity: item.quantity,
            })),
            num_items: purchaseData.items.reduce((sum, item) => sum + item.quantity, 0),
          });

          ReactGA.event('purchase', {
            currency: 'USD',
            transaction_id: purchaseData.groupOrderId,
            value: subtotalInMajorUnits,
            coupon: purchaseData.promoCode,
            items: purchaseData.items.map((item) => ({
              item_id: item.foodItemId,
              quantity: item.quantity,
              affiliation: item.shefId,
            })),
          });
          this.adwordsTrack(event, {
            currency: 'USD',
            value: subtotalInMajorUnits,
            transaction_id: transactionId,
          });

          this.linkedInTrack('5990484');

          this.singularRevenue('Purchase', 'USD', subtotalInMajorUnits, {
            transaction_id: transactionId,
          });
          break;
        }
        case ClientEvents.NEW_USER_PURCHASE: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const purchaseData = data as ClientTrackableEvents[ClientEvents.NEW_USER_PURCHASE];
          const subtotalInMajorUnits = purchaseData.subtotal / 100.0;
          const transactionId = String(purchaseData.groupOrderId);
          const items = (purchaseData as any).items ?? [];
          // Marketplace Meta event — custom name keeps Meta optimization WSS-only.
          this.fbTrack('MarketplacePurchase', {
            value: subtotalInMajorUnits,
            currency: 'USD',
            content_ids: items.map((item: PurchaseItemData) => String(item.foodItemId)),
            content_type: 'product',
            contents: items.map((item: PurchaseItemData) => ({
              id: String(item.foodItemId),
              quantity: item.quantity,
            })),
            num_items: items.reduce((sum: number, item: PurchaseItemData) => sum + item.quantity, 0),
          });
          this.adwordsTrack(event, {
            transaction_id: transactionId,
            currency: 'USD',
            value: subtotalInMajorUnits,
          });
          this.singularEvent(ClientEvents.NEW_USER_PURCHASE, { value: subtotalInMajorUnits, currency: 'USD' });

          googleTagManagerArgs.event = GoogleTagManagerEventNames.NEW_USER_PURCHASE;
          googleTagManagerArgs.conversionSubtotal = subtotalInMajorUnits;
          googleTagManagerArgs.orderId = `${purchaseData.groupOrderId}`;
          this.gtmTrack(googleTagManagerArgs);

          break;
        }
        case ClientEvents.EXISTING_USER_PURCHASE: {
          const purchaseData = data as ClientTrackableEvents[ClientEvents.EXISTING_USER_PURCHASE];
          const subtotalInMajorUnits = purchaseData.subtotal / 100.0;
          const transactionId = String(purchaseData.groupOrderId);
          googleTagManagerArgs.event = GoogleTagManagerEventNames.EXISTING_USER_PURCHASE;
          googleTagManagerArgs.conversionSubtotal = subtotalInMajorUnits;
          googleTagManagerArgs.orderId = `${purchaseData.groupOrderId}`;
          this.singularEvent(ClientEvents.EXISTING_USER_PURCHASE, { value: subtotalInMajorUnits, currency: 'USD' });
          const items = (purchaseData as any).items ?? [];
          // Marketplace Meta event — custom name keeps Meta optimization WSS-only.
          this.fbTrack('MarketplacePurchase', {
            value: subtotalInMajorUnits,
            currency: 'USD',
            content_ids: items.map((item: PurchaseItemData) => String(item.foodItemId)),
            content_type: 'product',
            contents: items.map((item: PurchaseItemData) => ({
              id: String(item.foodItemId),
              quantity: item.quantity,
            })),
            num_items: items.reduce((sum: number, item: PurchaseItemData) => sum + item.quantity, 0),
          });

          this.adwordsTrack(event, {
            transaction_id: transactionId,
            currency: 'USD',
            value: subtotalInMajorUnits,
          });
          this.gtmTrack(googleTagManagerArgs);
          break;
        }
        case ClientEvents.SUBSCRIPTION_PURCHASE: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const purchaseData = data as ClientTrackableEvents[ClientEvents.SUBSCRIPTION_PURCHASE];
          const subtotalInMajorUnits = purchaseData.subtotal / 100.0;
          this.fbTrack('Subscribe', { value: subtotalInMajorUnits, currency: 'USD' });
          break;
        }
        case ClientEvents.MEAL_PLANNING_MVP_CHECKOUT_STARTED: {
          // Convert from cents to dollars for proper value reporting
          const valueInDollars = (data.weeklySubtotal ?? 0) / 100.0;
          const trackData = {
            ...data,
            value: valueInDollars,
            currency: 'USD',
          };
          this.fbTrack('InitiateCheckout', trackData);
          this.fbTrack(event, trackData);
          this.adwordsTrack(event, trackData);
          googleTagManagerArgs.event = GoogleTagManagerEventNames.MEAL_PLANNING_MVP_CHECKOUT_STARTED;
          googleTagManagerArgs.conversionSubtotal = valueInDollars;
          this.gtmTrack(googleTagManagerArgs);
          break;
        }
        case ClientEvents.MEAL_PLANNING_MVP_DELIVERY_ADDRESS_SELECT: {
          // Don't send to Meta - not part of standard funnel
          this.adwordsTrack(event, data);
          googleTagManagerArgs.event = GoogleTagManagerEventNames.MEAL_PLANNING_MVP_DELIVERY_ADDRESS_SELECT;
          this.gtmTrack(googleTagManagerArgs);
          break;
        }
        case ClientEvents.MEAL_PLANNING_MVP_PURCHASE_ATTEMPT: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const purchaseData = data as ClientTrackableEvents[ClientEvents.MEAL_PLANNING_MVP_PURCHASE_ATTEMPT];
          // Convert from cents to dollars for proper value reporting
          const valueInDollars = (purchaseData.finalPrice ?? 0) / 100.0;
          const trackData = {
            ...purchaseData,
            value: valueInDollars,
            currency: 'USD',
          };
          // Don't send to Meta - purchase attempts are not standard events, only completed purchases
          this.adwordsTrack(event, {
            ...trackData,
          });
          googleTagManagerArgs.event = GoogleTagManagerEventNames.MEAL_PLANNING_MVP_PURCHASE_ATTEMPT;
          this.gtmTrack(googleTagManagerArgs);
          break;
        }
        case ClientEvents.MEAL_PLANNING_MVP_PURCHASE: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const purchaseData = data as ClientTrackableEvents[ClientEvents.MEAL_PLANNING_MVP_PURCHASE];
          // Convert from cents to dollars for proper value reporting
          // Talk to TagHero to figure out how to handle standard purchase events vs. custom events
          const subtotalInMajorUnits = (purchaseData.weeklySubtotal ?? 0) / 100.0;
          const finalPriceInDollars = (purchaseData.finalPrice ?? 0) / 100.0;
          this.fbTrack('Purchase', {
            value: subtotalInMajorUnits,
            currency: 'USD',
          });
          const trackData = {
            ...purchaseData,
            value: subtotalInMajorUnits,
            currency: 'USD',
          };
          this.fbTrack(event, trackData);

          googleTagManagerArgs.event = GoogleTagManagerEventNames.MEAL_PLAN_PURCHASE;
          googleTagManagerArgs.conversionSubtotal = finalPriceInDollars;
          googleTagManagerArgs.orderId = purchaseData.groupOrderId ?? undefined;
          this.adwordsTrack(event, {
            value: subtotalInMajorUnits,
            currency: 'USD',
          });
          this.gtmTrack(googleTagManagerArgs);
          break;
        }
        case ClientEvents.CART_ADD_ITEM: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const cartAddItemData = data as ClientTrackableEvents[ClientEvents.CART_ADD_ITEM];
          googleTagManagerArgs.event = GoogleTagManagerEventNames.CART_ADD_ITEM;
          this.gtmTrack(googleTagManagerArgs);
          this.adwordsTrack(event, {
            currency: 'USD',
            value: cartAddItemData.price,
          });
          this.singularEvent(ClientEvents.CART_ADD_ITEM, { value: cartAddItemData.price, currency: 'USD' });
          this.fbTrack('AddToCart', {
            content_ids: [cartAddItemData.id],
            content_type: 'product',
            value: cartAddItemData.price,
            currency: 'USD',
          });
          break;
        }
        case ClientEvents.CART_REMOVE_ITEM: {
          // Don't send to Meta - not part of standard funnel
          break;
        }
        case ClientEvents.DISH_MODAL_VISIT:
        case ClientEvents.SHEF_MENU_VISIT: {
          this.fbTrack('ViewContent', {
            content_type: 'product',
          });
          this.adwordsTrack(event, {});
          break;
        }
        case ClientEvents.MEAL_PLANNING_MVP_ADD_TO_CART: {
          const mpAddData = data as any;
          this.fbTrack('AddToCart', {
            content_ids: [mpAddData.foodItemId],
            content_type: 'product',
            currency: 'USD',
          });
          googleTagManagerArgs.event = GoogleTagManagerEventNames.MEAL_PLANNING_MVP_ADD_TO_CART;
          this.gtmTrack(googleTagManagerArgs);
          break;
        }
        case ClientEvents.MEAL_PLANNING_MVP_FOOD_ITEM_RENDERED: {
          googleTagManagerArgs.event = GoogleTagManagerEventNames.MEAL_PLANNING_MVP_FOOD_ITEM_RENDERED;
          this.gtmTrack(googleTagManagerArgs);
          // Don't send to Meta - not part of standard funnel
          break;
        }
        case ClientEvents.MEAL_PLANNING_MVP_INTAKE_FORM_STEP: {
          googleTagManagerArgs.event = GoogleTagManagerEventNames.MEAL_PLANNING_MVP_INTAKE_FORM_STEP;
          this.gtmTrack(googleTagManagerArgs);
          // Don't send to Meta - not part of standard funnel
          break;
        }
        case ClientEvents.PAGE_VIEW: {
          // The Singular sdk automatically tracks the first page visit when it's initialized so we skip it
          // and only track every subsequent page view event.
          // https://support.singular.net/hc/en-us/articles/360039991491-Singular-Website-SDK-Native-Integration#2_Initializing_Singular
          if (this.hasReceivedFirstPageViewEvent && this.hasInitializedSingularSdk) {
            this.singularPageVisit();
          } else {
            this.hasReceivedFirstPageViewEvent = true;
          }

          this.fbTrack('PageView', data);
          googleTagManagerArgs.event = GoogleTagManagerEventNames.PAGE_VIEW;
          this.gtmTrack(googleTagManagerArgs);

          break;
        }
        case ClientEvents.REGISTER_SUCCESS:
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,no-case-declarations
          const typedData = data as ClientTrackableEvents[ClientEvents.REGISTER_SUCCESS];

          this.fbTrack(event, { fb_registration_method: typedData.method, ...typedData });
          this.adwordsTrack(event, {});
          googleTagManagerArgs.event = GoogleTagManagerEventNames.REGISTER_SUCCESS;
          this.gtmTrack(googleTagManagerArgs);
          this.singularEvent(event, { fb_registration_method: typedData.method });
          break;
        case ClientEvents.SHEF_APPLICATION_RECEIVED:
          // Don't send to Meta - not part of standard funnel
          this.adwordsTrack(event, {});
          googleTagManagerArgs.event = GoogleTagManagerEventNames.SHEF_APPLICATION_RECEIVED;
          this.gtmTrack(googleTagManagerArgs);
          this.singularEvent(ClientEvents.SHEF_APPLICATION_RECEIVED, {});
          break;
        case ClientEvents.SHEF_MEAL_PLAN_APPLICATION_STARTED:
          this.fbTrack(event, data);
          break;
        case ClientEvents.SHEF_MEAL_PLAN_QUESTIONNAIRE_COMPLETED:
          this.fbTrack(event, data);
          break;
        case ClientEvents.SHEF_MEAL_PLAN_APPLICATION_COMPLETED:
          this.fbTrack(event, data);
          break;
        case ClientEvents.MEAL_PLANNING_SPLASH_PAGE_LOADED:
          this.fbTrack(event, data);
          this.adwordsTrack(event, {});
          break;
        case ClientEvents.FOOD_SEARCH_RESULTS_DISPLAYED: // Too high volume, unnecessary
        case ClientEvents.SESSION_STARTED: // Too high volume, unnecessary
        case SharedEvents.EXPERIMENT_EXPOSURE: // Too high volume, unnecessary
          break;
        default:
          // Only send standard Meta events (PageView, ViewContent, AddToCart, InitiateCheckout, Purchase)
          // All other events are filtered out to reduce noise and focus on conversion funnel
          this.adwordsTrack(event, {});
      }
    } catch (err) {
      console.error(err);
    }
  }

  public onLogout(): void {
    this.userInfo = undefined;
    if (!this.adTrackingDisabled) {
      singularSdk.logout();
    }
  }
}
